'use client';
import type { AddEducationSchemaType } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-education/jobportal-add-education-dialog';
import { JobportalAddEducationDialog } from '@eliadmin/core/src/components/jobportal/jobportal-create-curriculum/jobportal-add-education/jobportal-add-education-dialog';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { useResponsiveDialogStore } from '@eliadmin/core/src/components/ui/responsive-dialog';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import type { CreateCurriculumSchema } from '@eliadmin/core/src/pages/(jobportal)/create-curriculum/page';
import { useFormContext } from 'react-hook-form';
import { FaPlusCircle } from 'react-icons/fa';

type JobportalAddEducationButtonProps = {
  className?: string;
  onJobAdded?: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const JobportalAddEducationButton = ({ className }: JobportalAddEducationButtonProps) => {
  const { t } = useTranslations();

  const openDialog = useResponsiveDialogStore(s => s.open);

  const form = useFormContext<CreateCurriculumSchema>();

  const onAddEducationSubmit = (data: AddEducationSchemaType) => {
    form.setValue('educations', [...(form.getValues('educations') || []), { ...data }]);
  };

  const handleAddEducationClick = () => {
    openDialog({
      id: JobportalAddEducationDialog.id,
      content: (
        <JobportalAddEducationDialog
          onSubmit={onAddEducationSubmit}
          newId={
            (form.getValues('educations') && form.getValues('educations')!.length > 0
              ? Math.max(
                  ...form
                    .getValues('educations')!
                    .map((e: any) => (typeof e?.id === 'number' ? e.id : 0)),
                ) + 1
              : 1) as number
          }
        />
      ),
    });
  };

  return (
    <Button
      type={'button'}
      className="flex gap-3 sm:max-w-min"
      onClick={() => handleAddEducationClick()}
    >
      <FaPlusCircle className={'h-6 w-6'} />
      <p className="whitespace-nowrap">{t('text880')}</p>
    </Button>
  );
};
